import { render } from "./XIconSolidMapPin.vue?vue&type=template&id=ed6b65a4"
import script from "./XIconSolidMapPin.vue?vue&type=script&lang=js"
export * from "./XIconSolidMapPin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidMapPin.vue"]])

export default __exports__